import src from "IMAGE";
export default { src, width: 406, height: 370, blurWidth: 0, blurHeight: 0};
